const optionCollator = new Intl.Collator(undefined, {
  numeric: true,
  sensitivity: 'base',
});

export const sortFilterOptions = (options: readonly string[]): string[] =>
  [...options].sort(optionCollator.compare);